export enum HowItWorksViewType {
  FREELANCER = 'freelancer',
  CLIENT = 'client',
}
